import { handleActions } from 'redux-actions';
import { EditorState } from '../types';
import { closeMuro, openMuro, updateMenus } from '../actions/editor';

export default handleActions<EditorState['editor'], any>(
  {
    [`${updateMenus}`]: (state, action: ReturnType<typeof updateMenus>) => ({
      ...state,
      menuUpdates: (state.menuUpdates ?? 0) + 1,
    }),
    [`${openMuro}`]: (state, action: ReturnType<typeof openMuro>) => ({
      ...state,
      muroOpen: true,
      muroProps: action.payload.props,
    }),
    [`${closeMuro}`]: (state, action: ReturnType<typeof closeMuro>) => ({
      ...state,
      muroOpen: false,
      muroProps: undefined,
    }),
  },
  {}
);
